import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { buildSharedQueryString } from "../hooks/useSharedParams";

export function Home() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        // Carry the shared params (anchor, countries, …) through the landing
        // redirect so deep links and the logo Link don't reset the anchor.
        const qs = buildSharedQueryString(searchParams);
        navigate(`/top${qs}`, { replace: true });
    }, [navigate, searchParams]);

    return null;
}
